<template>
  <div class="sign-in">
    <md-card md-with-hover v-cloak>
      <md-card-media>
        <img class="image" src="/static/maxima-logo.svg"/>
      </md-card-media>

      <md-card-header>
        <div class="md-title">Maxima-Online</div>
        <translate tag="div" class="md-subhead">Reset your password</translate>
      </md-card-header>

      <transition name="new-pwd">
        <md-card-content v-if="step === 1" key="step-1">
          <form novalidate @submit.stop.prevent="submit">
            <md-input-container id="email-error-div" :class="{'md-input-invalid': !validEmail(email) && emailDirty }">
              <translate tag="label">E-mail</translate>
              <md-input id="reset-email" @input.native="inputEmail()" type="email" v-model="email"></md-input>
              <span class="md-error"><translate>Invalid e-mail</translate></span>
            </md-input-container>
          </form>
        </md-card-content>
      </transition>
      <transition name="new-pwd">
        <md-card-content v-if="step === 2" class="text-info" key="step-2">
          <translate>An e-mail with further instructions has been sent to the provided address.</translate>
        </md-card-content>
      </transition>

      <md-card-actions v-if="step === 1">
        <md-button id="request-new" @click.native="requestNew()" class="md-primary md-raised"><translate>Request new password</translate></md-button>
      </md-card-actions>
      <md-card-actions v-if="step === 2">
        <router-link tag="button" to="/sign-in" class="md-primary md-button"><translate>Return</translate></router-link>
      </md-card-actions>
    </md-card>
  </div>
</template>

<script>
import auth from '../../auth'
import validator from 'validator'

export default {
  name: 'reset-email',
  data () {
    return {
      email: '',
      emailDirty: false,
      step: 1
    }
  },
  methods: {
    requestNew () {
      this.emailDirty = true
      if (this.validEmail(this.email)) {
        this.step = 2
        auth.requestNew(this.email, this.$language.current)
      }
    },
    validEmail (email) {
      return validator.isEmail(email)
    },
    inputEmail () {
      this.emailDirty = true
    }
  }
}
</script>

<style scoped>
[v-cloak] {
  display: none!important;
}
.sign-in {
  width: 25rem;
  margin: 10em auto;
}
.image {
  width: 100% !important;
  padding: 30px 30px 10px 30px;
}
.text-info {
  margin-top: 20px;
}

.new-pwd-enter-active {
  transition: all .5s ease;
}
</style>



// WEBPACK FOOTER //
// src/components/login/ResetEmail.vue